
import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const DealersCPF = {
	name: NAME,
	apiProvider,
	router,
};
